import Joi from "joi";

const schema: any = Joi.object()
  .options({
    allowUnknown: true,
  })
  .messages({
    "string.empty": "This field is required",
    "string.email": "Email is not valid",
  });
export default schema;
